// 根据process.env.NODE_ENV区分
// 开发环境: development
// 生成环境: production
// 测试环境: test

let BASE_URL = ''
const TIME_OUT = 1000 * 60 * 1

if (process.env.NODE_ENV === 'development') {
  BASE_URL = '/devApi'
} else if (process.env.NODE_ENV === 'production') {
  BASE_URL = ''
} else {
  BASE_URL = ''
}
export { BASE_URL, TIME_OUT }
